/**
 * Is this apartment available (vacant)?
 *
 * `available` holds the site's status NAME in the page language ("Available",
 * "פנוי", "Verfügbar"…), so comparing it with fixed strings breaks for any
 * other language — on German sites every unit looked occupied. The host page
 * (olyo-ai) now sends `is_available`, computed from the status in any
 * language; the name list stays as a fallback for hosts that don't.
 */
const AVAILABLE_NAMES = ["פנוי", "זמין", "available", "verfügbar", "verfuegbar", "frei"];

export function isApartmentAvailable(apartment) {
  if (!apartment) return false;
  if (typeof apartment.is_available === "boolean") return apartment.is_available;
  const name = String(apartment.available || "").trim().toLowerCase();
  return AVAILABLE_NAMES.includes(name);
}
